import { defineComponent as y, createElementBlock as l, createCommentVNode as s, openBlock as a, Fragment as g, withModifiers as i, normalizeClass as b, createTextVNode as f, createBlock as p, toDisplayString as m, capitalize as d, unref as o, withCtx as h, createVNode as u, createElementVNode as r } from "vue";
import { ScalarButton as k } from "@scalar/components";
import { ScalarIconEye as v } from "@scalar/icons";
const w = ["href"], C = ["href"], B = /* @__PURE__ */ y({
  __name: "HeaderItemTab",
  props: {
    tab: {},
    isEditable: { type: Boolean },
    isMobile: { type: Boolean },
    linkIsActive: { type: Function },
    resolveInternalLinks: { type: Function }
  },
  emits: ["navigate", "toggleShow"],
  setup(I) {
    return (e, t) => e.tab.show || e.isEditable ? (a(), l(g, { key: 0 }, [
      e.isMobile ? (a(), l("a", {
        key: 0,
        class: b(["header-item-link", {
          "header-item-active": e.linkIsActive(e.tab),
          "header-item-ghost": !e.tab.show
        }]),
        href: e.resolveInternalLinks(e.tab),
        onClick: t[1] || (t[1] = i((n) => e.$emit("navigate", e.tab.uid, e.tab.type), ["prevent"]))
      }, [
        f(m(e.tab.title || d(e.tab.type)) + " ", 1),
        !e.tab.show && e.isEditable ? (a(), p(o(k), {
          key: 0,
          class: "header-item-show-button",
          variant: "ghost",
          onClick: t[0] || (t[0] = i((n) => e.$emit("toggleShow", e.tab.uid, e.tab.type), ["stop"]))
        }, {
          default: h(() => [
            u(o(v)),
            t[4] || (t[4] = r("span", null, "Show", -1))
          ]),
          _: 1
        })) : s("", !0)
      ], 10, w)) : (a(), l("a", {
        key: 1,
        class: b(["header-item-link", {
          "header-item-active": e.linkIsActive(e.tab),
          "header-item-ghost": !e.tab.show
        }]),
        href: e.resolveInternalLinks(e.tab),
        onClick: t[3] || (t[3] = i((n) => e.$emit("navigate", e.tab.uid, e.tab.type), ["prevent"]))
      }, [
        r("span", null, m(e.tab.title || d(e.tab.type)), 1),
        !e.tab.show && e.isEditable ? (a(), p(o(k), {
          key: 0,
          class: "header-item-show-button",
          variant: "ghost",
          onClick: t[2] || (t[2] = i((n) => e.$emit("toggleShow", e.tab.uid, e.tab.type), ["stop"]))
        }, {
          default: h(() => [
            u(o(v), { weight: "fill" }),
            t[5] || (t[5] = r("span", null, "Show", -1))
          ]),
          _: 1
        })) : s("", !0)
      ], 10, C))
    ], 64)) : s("", !0);
  }
});
export {
  B as default
};
